import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { saveCarePlan } from "../../actions/saveCarePlan";
import { useEffect, useState } from "react";
import { getCarePlanData, resetWizardStore } from "../../actions/wizard";
import useClientId from "../../hooks/useClientId";
import { getAssignedClientProfile } from "../../actions/getAssignedClientProfile";
import { AllRoutes } from "../../routes";
import {
  decryptPermissions,
  isPermissionExists,
} from "../../utils/permissionsHelpers";
import { ROUTE_CODES } from "../../routes/route-codes";
import useApiCancellation from "../../hooks/useApiCancellation";

const Menu = () => {
  const { cancelAllRequests } = useApiCancellation();
  const [userPermissions, setUserPermissions] = useState([]);
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { clientId } = useClientId();
  const storeAuth = useSelector((state) => state.auth);
  const storeSettings = useSelector((state) => state.settings);

  const routeMap = {};
  AllRoutes.forEach((route) => {
    routeMap[route.code] = route;
  });

  const handleNavigation = (to) => {
    // Cancel all pending API requests before navigating
    cancelAllRequests();
    navigate(to);
  };

  // effects
  useEffect(() => {
    // save/submit/trigger-API's for client data
    // reset wizard after data submission
    // if user clicks on back/forward button then get support plan for current client from URL
    if (
      !!storeSettings &&
      Object.keys(storeSettings).length > 0 &&
      storeSettings.generalSetting?.prevRoute
    ) {
      const prevRoute = storeSettings.generalSetting?.prevRoute;
      if (prevRoute && prevRoute !== location.pathname) {
        if (prevRoute.includes("plan/")) {
          const path = prevRoute.split("/");
          const prevClientId = parseInt(path[path.length - 1]);
          dispatch(saveCarePlan(prevClientId)).then(() => {
            dispatch(resetWizardStore()).then(() => {
              if (!!clientId && !!prevClientId && prevClientId !== clientId) {
                dispatch(getAssignedClientProfile(clientId));
                dispatch(getCarePlanData(clientId));
              }
            });
          });
        }
        dispatch({
          type: "SETTINGS_UPDATE",
          setting: "prevRoute",
          value: location.pathname,
        });
      }
    }
  }, [location]);

  useEffect(() => {
    if (isPermissionExists()) {
      const permissions = decryptPermissions();
      const filteredPermissions = permissions.reduce((acc, curr) => {
        if (location.pathname.includes("calendar-viewer")) {
          if (
            curr.path.includes("/editor") &&
            location.pathname.includes("/editor")
          ) {
            acc.push(curr);
          } else if (
            curr.path.includes("/viewer") &&
            location.pathname.includes("/viewer")
          ) {
            acc.push(curr);
          }
        } else {
          if (
            curr.code !== "CALENDAR_VIEWER" &&
            curr.code !== "CALENDAR_VIEWER_EDITOR" &&
            curr.code !== "CALENDAR_VIEWER_VIEWER"
          ) {
            acc.push(curr);
          }
        }
        return acc;
      }, []);
      setUserPermissions(filteredPermissions);
    } else {
      navigate("/login");
    }
  }, [storeAuth, location.pathname]);

  return (
    <div className="app-sidebar">
      <ul className="navbar-nav sidebar sidebar-dark">
        <li className="nav-item">
          <NavLink
            to={`/dashboard`}
            className="nav-link"
            activeclassname="active"
            onClick={() => handleNavigation("/dashboard")}
          >
            {routeMap[ROUTE_CODES.DASHBOARD]?.icon}
            <span>Dashboard</span>
          </NavLink>
        </li>
        {userPermissions?.length > 0 &&
          userPermissions.map(
            (routeDetail) =>
              routeDetail.assignable && (
                <li className="nav-item" key={routeDetail.path}>
                  <NavLink
                    to={`/${routeDetail.path}`}
                    className="nav-link"
                    activeclassname="active"
                    onClick={() => handleNavigation(`/${routeDetail.path}`)}
                  >
                    {routeMap[routeDetail.code]?.icon}
                    <span>{routeDetail.name}</span>
                  </NavLink>
                </li>
              ),
          )}
      </ul>
    </div>
  );
};
export default Menu;
